import { render, staticRenderFns } from "./index.vue?vue&type=template&id=53501194&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53501194",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/demo/index.vue
// module id = null
// module chunks = 